import React, { Component } from 'react';
import { Text, View, ActivityIndicator } from 'core';
import { style, theme } from 'constants';
import * as actions from 'actions';
import { lang } from 'lang';

export class StatusBox extends Component {
  componentDidUpdate() {
    const { status, onSuccess } = this.props;
    if (status.is_success && onSuccess) {
      onSuccess();
      actions.fetch.markFinished(status.type);
    }
  }
  componentWillUnmount() {
    const { status } = this.props;
    (status.is_error || status.is_success) && actions.fetch.markFinished(status.type);
  }

  render() {
    const { status, style, color } = this.props;
    const box = (
      <View style={[styles.box, style, status.is_error && styles.error]}>
        {status.is_loading && <ActivityIndicator color={color || theme.primary_color} />}
        <Text style={{ color: color || theme.gray_color }}>{status.is_error && (lang.ERROR[status.error_message] || status.error_message)}</Text>
      </View>
    );
    return status.is_error || status.is_loading || status.is_success ? box : null;
  }
}
const styles = style({});



// WEBPACK FOOTER //
// ./src/components/core/status_box.js